export enum ContentViewModeType {
    Home = 'Home',
    Course = 'Course',
    Lecture = 'Lecture',
    Slide = 'Slide',
}
